import React, { useState } from 'react';
import styles from './ImageUrlModal.module.css';
import { IoClose, IoAdd } from 'react-icons/io5';

const ImageUrlModal = ({ isOpen, onClose, onSubmit, embedded = false }) => {
  const [imageUrls, setImageUrls] = useState(['']);
  const [previews, setPreviews] = useState([]);

  const handleAddInput = () => {
    setImageUrls([...imageUrls, '']);
  };

  const handleRemoveInput = (index) => {
    const newUrls = imageUrls.filter((_, i) => i !== index);
    const newPreviews = previews.filter((_, i) => i !== index);
    setImageUrls(newUrls);
    setPreviews(newPreviews);
  };

  const handleUrlChange = (index, value) => {
    const newUrls = [...imageUrls];
    newUrls[index] = value;
    setImageUrls(newUrls);

    // Update preview if URL is valid
    try {
      const url = new URL(value);
      const newPreviews = [...previews];
      newPreviews[index] = value;
      setPreviews(newPreviews);
    } catch (e) {
      // Invalid URL - remove preview
      const newPreviews = [...previews];
      newPreviews[index] = null;
      setPreviews(newPreviews);
    }
  };

  const handleSubmit = () => {
    // Filter out empty URLs
    const validUrls = imageUrls.filter(url => {
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    });
    onSubmit(validUrls);
    setImageUrls(['']);
    setPreviews([]);
  };

  // If not open and not embedded, don't render
  if (!isOpen) return null;

  // In embedded mode, don't render modal wrapper
  const content = (
    <>
      {!embedded && (
        <button className={styles.closeButton} onClick={onClose}>
          <IoClose size={24} />
        </button>
      )}
      
      {!embedded && <h3>Add Image URLs</h3>}
      
      <div className={styles.inputList}>
        {imageUrls.map((url, index) => (
          <div key={index} className={styles.inputGroup}>
            <input
              type="url"
              value={url}
              onChange={(e) => handleUrlChange(index, e.target.value)}
              placeholder="Enter image URL"
              className={styles.urlInput}
            />
            {index > 0 && (
              <button
                className={styles.removeButton}
                onClick={() => handleRemoveInput(index)}
              >
                <IoClose size={18} />
              </button>
            )}
          </div>
        ))}
        <button className={styles.addButton} onClick={handleAddInput}>
          <IoAdd size={18} /> Add Another URL
        </button>
      </div>
      {previews.some(p => p) && (
        <div className={styles.previewContainer}>
          {previews.map((url, index) => (
            url && (
              <div key={index} className={styles.previewItem}>
                <img src={url} alt={`Preview ${index + 1}`} />
                <button
                  className={styles.removePreview}
                  onClick={() => handleRemoveInput(index)}
                >
                  <IoClose size={18} />
                </button>
              </div>
            )
          ))}
        </div>
      )}
      <div className={styles.actionButtons}>
        {!embedded && (
          <button className={styles.cancelButton} onClick={onClose}>Cancel</button>
        )}
        <button
          className={styles.submitButton}
          onClick={handleSubmit}
          disabled={!imageUrls.some(url => url.trim())}
        >
          Add Images
        </button>
      </div>
    </>
  );

  // If embedded, return content only
  if (embedded) {
    return content;
  }

  // Otherwise return modal wrapper
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        {content}
      </div>
    </div>
  );
};

export default ImageUrlModal;